query EntityApprovalTopic($entityId: UUID!) {
  entityApprovalTopic(entityId: $entityId)
}
